'use strict';

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var Assert = require('./assert');
var Clone = require('./clone');
var Merge = require('./merge');
var Reach = require('./reach');
var internals = {};
module.exports = function (defaults, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Assert(defaults && typeof defaults === 'object', 'Invalid defaults value: must be an object');
  Assert(!source || source === true || typeof source === 'object', 'Invalid source value: must be true, falsy or an object');
  Assert(typeof options === 'object', 'Invalid options: must be an object');
  if (!source) {
    // If no source, return null
    return null;
  }
  if (options.shallow) {
    return internals.applyToDefaultsWithShallow(defaults, source, options);
  }
  var copy = Clone(defaults);
  if (source === true) {
    // If source is set to true, use defaults
    return copy;
  }
  var nullOverride = options.nullOverride !== undefined ? options.nullOverride : false;
  return Merge(copy, source, {
    nullOverride: nullOverride,
    mergeArrays: false
  });
};
internals.applyToDefaultsWithShallow = function (defaults, source, options) {
  var keys = options.shallow;
  Assert(Array.isArray(keys), 'Invalid keys');
  var seen = new Map();
  var merge = source === true ? null : new Set();
  var _iterator = _createForOfIteratorHelper(keys),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;
      key = Array.isArray(key) ? key : key.split('.'); // Pre-split optimization

      var ref = Reach(defaults, key);
      if (ref && typeof ref === 'object') {
        seen.set(ref, merge && Reach(source, key) || ref);
      } else if (merge) {
        merge.add(key);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var copy = Clone(defaults, {}, seen);
  if (!merge) {
    return copy;
  }
  var _iterator2 = _createForOfIteratorHelper(merge),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _key = _step2.value;
      internals.reachCopy(copy, source, _key);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  var nullOverride = options.nullOverride !== undefined ? options.nullOverride : false;
  return Merge(copy, source, {
    nullOverride: nullOverride,
    mergeArrays: false
  });
};
internals.reachCopy = function (dst, src, path) {
  var _iterator3 = _createForOfIteratorHelper(path),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _segment = _step3.value;
      if (!(_segment in src)) {
        return;
      }
      var val = src[_segment];
      if (typeof val !== 'object' || val === null) {
        return;
      }
      src = val;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  var value = src;
  var ref = dst;
  for (var i = 0; i < path.length - 1; ++i) {
    var segment = path[i];
    if (typeof ref[segment] !== 'object') {
      ref[segment] = {};
    }
    ref = ref[segment];
  }
  ref[path[path.length - 1]] = value;
};